"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var Controller_1 = require("../Controller");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var routeParams_1 = require("../routeParams");
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var UpdateProgress_1 = require("@wix/social-groups-common/dist/src/components/ContentEditor/UpdateProgress");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var GroupController = /** @class */ (function (_super) {
    tslib_1.__extends(GroupController, _super);
    function GroupController(controllerConfig, experiments, group) {
        var _this = _super.call(this, controllerConfig, group.groupId) || this;
        _this.controllerConfig = controllerConfig;
        _this.experiments = experiments;
        _this.group = group;
        _this.pageReady = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setState({
                    changeTab: this.changeTab,
                    actions: {
                        changeTab: this.changeTab,
                        getExternalVideoMetadata: this.getVideoMetadata,
                        uploadFiles: this.uploadFiles,
                        updateGroup: this.updateGroup,
                        configureApps: this.configureApps,
                        setEditMode: this.setEditMode,
                        deleteGroup: this.deleteGroup,
                        goToGroupList: this.goToGroupList,
                        joinGroup: this.joinGroup,
                        withdrawJoinRequest: this.withdrawJoinRequest,
                        leaveGroup: this.leaveGroup,
                        inviteMemberByEmail: this.inviteMemberByEmail,
                        fetchGroupRules: this.fetchGroupRules.bind(this),
                    },
                    promptLogin: this.promptLogin,
                });
                return [2 /*return*/];
            });
        }); };
        _this.uploadFiles = function (filename, file, manualProgressControl) {
            if (manualProgressControl === void 0) { manualProgressControl = false; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var uploadFile, data, e_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!manualProgressControl) {
                                this.setState({ updateProgress: UpdateProgress_1.UpdateProgress.UPDATING });
                            }
                            uploadFile = { filename: filename, uploadResponse: null, error: null };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, this.mediaApi.uploadFile(file)];
                        case 2:
                            data = (_a.sent()).data;
                            uploadFile.uploadResponse = data;
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _a.sent();
                            uploadFile.error = e_1.response.data;
                            return [3 /*break*/, 5];
                        case 4:
                            this.setState({
                                uploadedRegistry: this.state.uploadedRegistry.concat([uploadFile]),
                            });
                            if (!manualProgressControl) {
                                this.setState({ updateProgress: UpdateProgress_1.UpdateProgress.STALE });
                            }
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getVideoMetadata = function (videoUrl) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var metadataResponse, data, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ updateProgress: UpdateProgress_1.UpdateProgress.UPDATING });
                        metadataResponse = { videoUrl: videoUrl, metadata: null, error: null };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.videoMetadataApi.getVideoMetadata(videoUrl)];
                    case 2:
                        data = (_a.sent()).data;
                        metadataResponse.metadata = data;
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        metadataResponse.error = e_2.response.data;
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState({
                            externalVideosMetadataRegistry: [metadataResponse],
                            updateProgress: UpdateProgress_1.UpdateProgress.STALE,
                        });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.withdrawJoinRequest = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.changeMembership(this.groupModel.withdrawJoinRequest)];
            });
        }); };
        _this.leaveGroup = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.changeMembership(this.groupModel.leaveGroup)];
            });
        }); };
        _this.joinGroup = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.changeMembership(this.groupModel.joinGroup)];
            });
        }); };
        _this.handleLocationChange = function (_a) {
            var path = _a.path;
            var _b = tslib_1.__read(path, 4), tab = _b[2], _c = _b[3], feedItemId = _c === void 0 ? null : _c;
            _this.setState({
                activeTab: tab,
                feedItemId: feedItemId,
            });
        };
        _this.changeTab = function (tab) {
            if (_this.isEditorMode()) {
                return _this.setState({ activeTab: tab });
            }
            var location = _this.getLocation();
            var _a = _this.getRouteParams(), groupId = _a.groupId, section = _a.section;
            location.to("/" + section + "/" + groupId + "/" + tab);
        };
        _this.setGroup = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var group, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.groupModel.fetch()];
                    case 1:
                        group = _a.sent();
                        this.setState({ group: group });
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.changeMembership = function (membershipAction) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var group;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUserLoggedIn()) return [3 /*break*/, 3];
                        group = this.state.group;
                        //TODO: progress state
                        return [4 /*yield*/, membershipAction.bind(this.groupModel, group)()];
                    case 1:
                        //TODO: progress state
                        _a.sent();
                        this.publishMembersUpdate(group.groupId);
                        return [4 /*yield*/, this.setGroup()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.promptLogin()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.setEditMode = function (updateProgress) {
            _this.setState({ updateProgress: updateProgress });
        };
        _this.updateGroup = function (paths, details, settings) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var group;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ updateProgress: UpdateProgress_1.UpdateProgress.UPDATING });
                        this.groupModel.updateGroup(paths, details, settings);
                        return [4 /*yield*/, this.groupModel.update()];
                    case 1:
                        group = _a.sent();
                        this.setState({ group: group, updateProgress: UpdateProgress_1.UpdateProgress.STALE });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.configureApps = function (apps) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var updatedApps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ updateProgress: UpdateProgress_1.UpdateProgress.UPDATING });
                        return [4 /*yield*/, this.groupModel.configureApps({ apps: apps })];
                    case 1:
                        updatedApps = _a.sent();
                        this.setState({ updateProgress: UpdateProgress_1.UpdateProgress.STALE, apps: updatedApps });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.inviteMemberByEmail = function (email) {
            return _this.groupModel.inviteMemberByEmail(email);
        };
        _this.deleteGroup = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupName, location_1, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        groupName = this.groupModel.getTitle();
                        return [4 /*yield*/, this.groupModel.delete()];
                    case 1:
                        _a.sent();
                        controllers_1.AppToastsController.publish(this.controllerConfig.platformAPIs.pubSub, {
                            type: social_groups_api_1.AppToastTypes.GROUP_DELETED,
                            options: {
                                'group-name': groupName,
                            },
                        });
                        location_1 = this.getLocation();
                        location_1.to('/groups');
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        console.error('Delete Group failed');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.initExternalServices(_this.getSiteToken(), group.groupId);
        _this.getLocation().onChange(_this.handleLocationChange);
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var id;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getGroupId()];
                        case 1:
                            id = _b.sent();
                            this.initExternalServices(instance, id);
                            return [4 /*yield*/, this.setGroup()];
                        case 2:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        });
        _this.setSubscriptions();
        return _this;
    }
    GroupController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, activeTab, feedItemId, initialProps, _b, e_5;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.getRouteParams(), activeTab = _a.activeTab, feedItemId = _a.feedItemId;
                        initialProps = {
                            locale: this.getLocale(),
                            cssBaseUrl: this.getCssBaseUrl(),
                            activeTab: activeTab,
                            feedItemId: feedItemId,
                            uploadedRegistry: [],
                            externalVideosMetadataRegistry: [],
                            isLoggedIn: this.isUserLoggedIn(),
                            updateProgress: UpdateProgress_1.UpdateProgress.STALE,
                            group: this.group,
                            loading: false,
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _b = initialProps;
                        return [4 /*yield*/, this.groupModel.getApps()];
                    case 2:
                        _b.apps = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _c.sent();
                        console.log('GroupController.getInitialProps: FAILED to fetch GroupApps');
                        return [3 /*break*/, 4];
                    case 4:
                        this.state = initialProps;
                        return [2 /*return*/, Promise.resolve(initialProps)];
                }
            });
        });
    };
    GroupController.prototype.setState = function (props) {
        this.state = tslib_1.__assign({}, this.state, props);
        this.controllerConfig.setProps(props);
    };
    GroupController.prototype.fetchGroupRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rules;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.groupModel.getRules()];
                    case 1:
                        rules = _a.sent();
                        this.setState({ rules: rules });
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupController.prototype.getCssBaseUrl = function () {
        var _a = this.controllerConfig.appParams.baseUrls, staticsGroupBaseUrl = _a.staticsGroupBaseUrl, staticsBaseUrl = _a.staticsBaseUrl;
        return staticsGroupBaseUrl || staticsBaseUrl;
    };
    GroupController.prototype.getRouteParams = function () {
        var location = this.getLocation();
        return routeParams_1.groupRoute(location);
    };
    GroupController.prototype.initExternalServices = function (instance, groupId) {
        this.apiClient = new social_groups_api_1.default(instance, this.getApiBaseUrl());
        this.mediaApi = new social_groups_api_1.MediaApi(this.apiClient);
        var location = this.getLocation();
        this.videoMetadataApi = new social_groups_api_1.VideoMetadataApi(instance, baseUrl_1.getRCApiBaseUrl(location.baseUrl));
        this.groupModel = new social_groups_api_1.Group(groupId, this.apiClient, this.controllerConfig.platformAPIs);
    };
    GroupController.prototype.setSubscriptions = function () {
        try {
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.UPDATE_GROUP_EVENT, this.setGroup, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    GroupController.prototype.publishMembersUpdate = function (groupId) {
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.UPDATE_MEMBERS_EVENT, groupId, false);
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.UPDATE_CONTEXT_TOKENS_EVENT, groupId, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    GroupController.prototype.getGroupApps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var apps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.groupModel.getApps()];
                    case 1:
                        apps = _a.sent();
                        this.setState({ apps: apps });
                        return [2 /*return*/];
                }
            });
        });
    };
    return GroupController;
}(Controller_1.Controller));
exports.GroupController = GroupController;
//# sourceMappingURL=controller.js.map